import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GlobalComponent } from 'src/app/global/global.component';
import { GeneralService } from 'src/app/service/general.service';
import { ClientSupportRelationDateService } from '../../client-employee-contact/client-support-relation.service';
import { DateService } from 'src/app/date.service';
import { ClientEmployeeContactService } from '../../client-employee-contact/client-employee-contact.service';
import { CommonHttpService } from 'src/app/common.service';
import { ClientHttpService } from '../client-parent.service';
import { DataStateChangeEventArgs, FilterSettingsModel, GridComponent } from '@syncfusion/ej2-angular-grids';
import { IMyDpOptions } from 'mydatepicker';
import { ClientEmployeeContactBO, ClientSupportRelationShipBO, ContactInfoLst, GetClientEvaluation } from '../../client-employee-contact/client-employee-contact.model';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-client-support-relation',
  templateUrl: './client-support-relation.component.html',
  styleUrls: ['./client-support-relation.component.scss']
})
export class ClientSupportRelationComponent implements OnInit {
    private onDestroy$: Subject<void> = new Subject<void>(); 
      @Input() ContactRelation: ClientEmployeeContactBO;     
 public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
   initialPage: object;
     filterOptions: FilterSettingsModel;   
    public myDatePickerOptions: IMyDpOptions = {
      dateFormat: "mm/dd/yyyy",
      showClearDateBtn: true,
      editableDateField: true,
    };
    ClientSupportRelationShipBO:ClientSupportRelationShipBO=new ClientSupportRelationShipBO();
     @ViewChild('gridsupportrelation') public gridsupportrelation: GridComponent;
  disabledsavedbutton: boolean = false;
  public datasupportrealtion: Observable<DataStateChangeEventArgs>;
    getclientsupport:GetClientEvaluation=new GetClientEvaluation();  
      savecontactinfo: ContactInfoLst = new ContactInfoLst();  
      ClientSupportRelationId:any;  
  SupportPlannersList: [{ Key: number, Value: string }];
  public formatOptions: object

  constructor(public global: GlobalComponent, public clientemployeeContactService
      : ClientEmployeeContactService, public toastrService: ToastrService, public general: GeneralService, public commonhttp: CommonHttpService, public ClientService: ClientHttpService,
      public dateservice:DateService,@Inject(ClientSupportRelationDateService) public clientnotesdateservice: ClientSupportRelationDateService,public datePipe:DatePipe) {
    this.datasupportrealtion = clientnotesdateservice;

       }

  ngOnInit(): void {
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };

     this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.filterOptions = { type: 'Menu' };
    this.getSupportPlannerDropdown();
    this.getSupportgrid();
  }



  getSupportgrid() {
    this.getclientsupport.clientId=this.ContactRelation.Id;
    this.clientnotesdateservice.executesupportrealation(this.getclientsupport);
     let count = 0;
  
     this.datasupportrealtion.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      console.log(data);      
     })
   }
   typenotes:string="";
     arraycol: any = [];
   public dataStateChangenotes(state): void {
  this.typenotes = (state.action.requestType).toString();

  if (this.typenotes == "filtering" && state.action.action != "clearFilter") {
    this.getclientsupport.field = state.action.currentFilterObject.field;
    this.getclientsupport.matchCase = state.action.currentFilterObject.matchCase;
    this.getclientsupport.operator = state.action.currentFilterObject.operator;
    this.getclientsupport.value = state.action.currentFilterObject.value;
   
    if(this.getclientsupport.type == 'number'){
      this.getclientsupport.value = (this.getclientsupport.value != null && this.getclientsupport.value != undefined)
      ? this.getclientsupport.value.toString() : null;
    }
    if(this.getclientsupport.type == "date" || this.getclientsupport.type == "datetime"){
      (!isNaN(Date.parse(this.getclientsupport.value)))
      ? this.global.getDateTimeString(new Date(this.getclientsupport.value)) : null;
    }
  }
  if((this.typenotes == "filtering" && state.action.action == "clearFilter") 
    || (this.getclientsupport.type != 'string' && (this.getclientsupport.value == null  || this.getclientsupport.value == undefined || this.getclientsupport.value == ''))) {
    this.getclientsupport.field = "notes";
    this.getclientsupport.matchCase = false;
    this.getclientsupport.operator = "startswith";
    this.getclientsupport.value = "";
    this.getclientsupport.type = "string"
  }
  this.getSupportgrid();
  if (this.typenotes == "paging" && state.action.noteTypeName == "actionBegin") {
    if (this.arraycol.length != 0) {
      if (this.arraycol[0].clientnotes.Pagesize != state.take) {
        this.arraycol[0].clientnotes.Pagesize = state.take;   

      }

    }
  }

 
}
SaveOrUpdateRelationInfo() {
    this.disabledsavedbutton = true;
    let saveContact: ClientSupportRelationShipBO = JSON.parse(JSON.stringify(this.ClientSupportRelationShipBO));
   // saveContact.id = this.savecontactinfo.id;    
    saveContact.activeDate =  saveContact.activeDate != null && saveContact.activeDate != undefined && saveContact.activeDate != ""? this.global.getDateTimeString(saveContact.activeDate):null;
    saveContact.inActiveDate =  saveContact.inActiveDate !=null &&  saveContact.inActiveDate != undefined && saveContact.inActiveDate != ""?  this.global.getDateTimeString(saveContact.inActiveDate):null;
    saveContact.clientId=this.ContactRelation.Id;
    if (this.ContactRelation.ContactType == 'Client') {
      this.clientemployeeContactService.SaveCliSupportInfo(saveContact).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        if (saveContact.id == "00000000-0000-0000-0000-000000000000") {
          document.getElementById('openSupportRelationModal').click();
          this.toastrService.success('Client Support Relationship saved successfully!');
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
         
          
        }
        else if (saveContact.id != "00000000-0000-0000-0000-000000000000") {
          document.getElementById('openSupportRelationModal').click();
          this.toastrService.success('Client Support Relationship updated successfully!');
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
         
         
        }
        this.disabledsavedbutton = false;
        this.getSupportgrid();
      }, (err: any) => {
        this.disabledsavedbutton = false;
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;
        }
      })
    }
   
  }
  clearCli_support() {
    this.ClientSupportRelationShipBO=new ClientSupportRelationShipBO();
    this.getSupportPlannerDropdown();
  }
   getSupportPlannerDropdown() {   
    this.clientemployeeContactService.getsupportplannerDropDown().pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: number, Value: string }]) => {
      this.SupportPlannersList = data;
    }, (err: any) => {
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    })
  }
 DateFormat(event, type, name) {
      if (type == "inputchanged") {
        if (name == "SaveStartDate") {
          let val = this.dateservice.inputFeildchangeReturnall(event);
          if (val != undefined) {
            let element = this.dateservice.inputFeildchangeReturnall(event);
            this.ClientSupportRelationShipBO.activeDate = element;

          }
        }
        if (name == "SaveEndDate") {
          let val = this.dateservice.inputFeildchangeReturnall(event);
          if (val != undefined) {
            let element = this.dateservice.inputFeildchangeReturnall(event);
            this.ClientSupportRelationShipBO.inActiveDate = element;
          }
        }
      }
      if (type == "datechanged") {
        if (name == "SaveStartDate") {
          let val = this.dateservice.Datechange(event);
          if (val != undefined) {
            let element = this.dateservice.Datechange(event);
            this.ClientSupportRelationShipBO.activeDate = element;
          }
        }
        if (name == "SaveEndDate") {
          let val = this.dateservice.Datechange(event);
          if (val != undefined) {
            let element = this.dateservice.Datechange(event);
            this.ClientSupportRelationShipBO.inActiveDate = element;
          }
        }
      }
    }
     setDeleteId(val) {
      this.ClientSupportRelationId=val;
      console.log(val,"val",this.ClientSupportRelationId,"ClientSupportRelationId");
    }
    DeleteClientSupport() {
      console.log("ClientSupportRelationId",this.ClientSupportRelationId)
        let param = new URLSearchParams()
        param.append("Id", this.ClientSupportRelationId)
      this.clientemployeeContactService.DeleteCliSupportInfo(param).subscribe((data: any) => {
        this.toastrService.success("Contact deleted successfully!");
        document.getElementById("openSupportdelete").click();
        this.getSupportgrid();
      },
        (err: any) => {
          if (err) {
            this.toastrService.error(err, 'Error'), 8000;
          }
        })
    }
   
    editData(val) {
        this.ClientSupportRelationShipBO.id=val.id;
        this.ClientSupportRelationShipBO.supportPlannerId=val.supportPlannerId;
        this.ClientSupportRelationShipBO.activeDate=val.activeDate != null ?this.datePipe.transform(val.activeDate, 'MM/dd/yyyy'):null;
        this.ClientSupportRelationShipBO.inActiveDate=val.inActiveDate != null ?this.datePipe.transform(val.inActiveDate, 'MM/dd/yyyy'):null;      

    }  
}
